import { render, staticRenderFns } from "./CreatePointeConsultation.vue?vue&type=template&id=9a1d9044&scoped=true"
import script from "./CreatePointeConsultation.vue?vue&type=script&lang=js"
export * from "./CreatePointeConsultation.vue?vue&type=script&lang=js"
import style0 from "./CreatePointeConsultation.vue?vue&type=style&index=0&id=9a1d9044&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a1d9044",
  null
  
)

export default component.exports